
  export default {
    props: {
      ratings: {
        type: Number,
        default: 0
      },
      reviewer: {
        type: String,
        default: ''
      },
       reviewDate: {
        type: String,
        default: ''
      },
    }
  }

